import { render, staticRenderFns } from "./productManagement.vue?vue&type=template&id=b005d11c&"
import script from "./productManagement.vue?vue&type=script&lang=js&"
export * from "./productManagement.vue?vue&type=script&lang=js&"
import style0 from "./productManagement.vue?vue&type=style&index=0&id=b005d11c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports